import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { IWorkTimeResponse } from '@cian/callback-widget';
import {
  fetchGetScheduleByUser,
  IGetScheduleByUserRequest,
  IGetScheduleByUserResponse200,
  IGetScheduleByUserResponse400,
} from '../../../shared/repositories/work-time/v1/get-schedule-by-user';
import { assertResponseError } from './asserts';
import { transformWorkTimeSchedule } from '../../../shared/mappers/transformWorkTimeSchedule';

export async function getWorkTimeSchedule(parameters: IGetScheduleByUserRequest): Promise<IWorkTimeResponse> {
  try {
    const httpApi = getHttpApi();

    const response = await fetchGetScheduleByUser<IGetScheduleByUserResponse200, IGetScheduleByUserResponse400>({
      httpApi,
      parameters,
    });

    assertResponseError(response);

    return transformWorkTimeSchedule(response.response);
  } catch (error) {
    const logger = getLogger();

    logger.error(error, {
      domain: 'browser.services.getWorkTimeSchedule()',
    });

    throw error;
  }
}
